<template>
    <div>
        <section>
                <div class="container">
                    <b-card no-body class="shadow p-3 mb-5 bg-white rounded m-4">
                        <b-row>
                            <b-col cols="3">
                                    <b-card no-body class="shadow p-3 mb-5 bg-white rounded">
                                        <div class="img-fluid">
                                            <img src="../assets/images/avatar.png" class="w-100" />
                                        </div>
                                        <div>
                                            <div class="p-2">
                                                <span>Hallo, <b>{{ this.currentUser.info.name }}</b> !</span>
                                                <span>{{ this.currentUser.info.email }}</span>
                                            </div>
                                        </div>
                                        <b-button
                                        block
                                        variant="primary"
                                        class="btn btn-custom theme-color text-white mr-auto px-4 rounded-0"
                                        v-for="tab in tabs"
                                        :key="tab"
                                        @click="selected = tab.replace(/\s/g, '');"
                                        :pressed="selected == tab.replace(/\s/g, '')"
                                        >
                                            {{ tab }}
                                        </b-button>
                                    </b-card>
                            </b-col>
                            <b-col>
                                <keep-alive>
                                    <component v-bind:is="selected"></component>
                                </keep-alive>
                            </b-col>
                        </b-row>
                    </b-card>
                </div>
        </section>

        <section>
            <Footer />
        </section>
    </div>
</template>

<script>
import PengajuanSaya from '../components/pengajuan-saya/pengajuan.vue'
import Profil from '../components/pengajuan-saya/profil.vue'
import Riwayat from '../components/pengajuan-saya/riwayat.vue'

export default {
  name: 'dashboard',
  data() {
    return {
        tabs: ["Pengajuan Saya", "Profil", "Riwayat"],
        selected: "Riwayat"
    };
  },
  components: {
    Profil,
    PengajuanSaya,
    Riwayat
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  created(){
      if(this.$route.query.q == 'Profil'){
          this.selected = "Profil"
      }
    }
};
</script>



// WEBPACK FOOTER //
// src/public/riwayat.vue